import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { BONUS_AMOUNT_TYPES } from 'js/components/main/BonusHistory/constants';
import { makeConfig } from '@theme/js/utils/makeConfig';
export * from '@core/js/components/main/BonusHistory/helpers';

export const getHeaderAmount = (item: IBonusToDisplay, translate: ITranslateMethod) => makeConfig({
    [BONUS_AMOUNT_TYPES.FREE_SPINS]: `${item.freeSpinsCount} ${translate('playtech.mobile.system.freespin.spins')}`,
    [BONUS_AMOUNT_TYPES.FREE_SPINS2]: `${item.freeSpinsCount} ${translate('playtech.mobile.system.freespin.spins')}`,
    [BONUS_AMOUNT_TYPES.GOLDEN_CHIPS]: `${item.goldenChipsCount} ${translate('playtech.mobile.system.goldenchips.chips')}`,
    default: item.amount
})(item.playType || '');
